export default __webpack_public_path__ + "static/iphoneX-bb784bbc232700ed1813a674a1538c46.png";